/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Util || (M.Template.Util = {});

M.Template.Util.Button = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n  <a>\n    <button class="'+
((__t=( M.html.htmlAttributeEscape(buttonClass) ))==null?'':__t)+
'\n        '+
((__t=( M.html.htmlAttributeEscape(disabledClass) ))==null?'':__t)+
'"\n        '+
((__t=( M.html.htmlAttributeEscape(disabledClass) ))==null?'':__t)+
'>\n      '+
((__t=( M.html.htmlAttributeEscape(buttonText) ))==null?'':__t)+
'\n    </button>\n  </a>\n';
}
return __p;
});

M.Template.Util.Counter = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   * All Rights Reserved
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n'+
((__t=( M.html.htmlAttributeEscape(copyContent) ))==null?'':__t)+
'\n';
}
return __p;
});

M.Template.Util.GridWidget = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="row titleRow">\n  ';
 if (isExpandCollapsible) { 
__p+='\n    <span class="arrowContainer floatL">\n      <img class="sprite arrowExpandedIcon arrowExpanded"\n        src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'">\n    </span>\n  ';
 } 
__p+='\n  <div class="gridTitleContainer floatL verticalCenter">\n    ';
 if (isExpandCollapsible) { 
__p+='\n      <span class="expandToggle">\n    ';
 } else { 
__p+='\n      <span class="noExpandToggle">\n    ';
 } 
__p+='\n      ';
 if (gridTitle) { 
__p+='\n        <h3 class="gridTitle floatL">'+
((__t=( M.html.htmlAttributeEscape(gridTitle) ))==null?'':__t)+
'</h3>\n      ';
 } 
__p+='\n    </span>\n    <div class="sectionRenameWrapper floatL">\n      <div class="sectionRenameSprite floatL"></div>\n      <div class="sectionRenameContainer floatL"></div>\n    </div>\n  </div>\n  <div class="counterContainer floatR verticalCenter"></div>\n  <div class="additionalTitleWidgets floatR"></div>\n  <div class="titleRightCorner floatR"></div>\n</div>\n<div class="gridSubheaderContainer"></div>\n<div class="expandCollapseContainer">\n  <div class="row gridHeader">\n    <div class="spritePlaceholder floatL"></div>\n    ';
 if (hasCheckboxColumn) { 
__p+='\n      <div class="checkboxCol checkbox gridCol floatL">\n        <input type="checkbox" class="gridWidgetCheckbox"/>\n      </div>\n    ';
 } 
__p+='\n    ';
 _.each(columns, function(column) { 
__p+='\n      <div class="'+
((__t=( M.html.htmlAttributeEscape(
        columnInfo[column]['className']) ))==null?'':__t)+
' gridCol floatL">\n        <h4 class="floatL">\n          '+
((__t=( M.html.htmlAttributeEscape(columnInfo[column]['header']) ))==null?'':__t)+
'\n        </h4>\n      </div>\n    ';
 }); 
__p+='\n  </div>\n  <div class="gridRowWrapper">\n    <ul\n      id="'+
((__t=( M.html.htmlAttributeEscape(gridId) ))==null?'':__t)+
'"\n      class="multisortable"></ul>\n  </div>\n  <div class="row gridFooter">\n    <div class="captionContainer"></div>\n    <div class="paginationContainer"></div>\n    <div class="actionContainer">\n      <div class="actionLinkContainer floatL"></div>\n      ';
 if (hasActionButtons) {
__p+='\n        <div class="storefrontToolsLinks floatR">\n          <div class="publishSectionButtonContainer floatR"></div>\n          <div class="previewSectionButtonContainer floatR"></div>\n          <div class="discardDraftButtonContainer floatR"></div>\n        </div>\n      ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Util.InfoDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   * All Rights Reserved
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n';
 if (bodyText) { 
__p+='\n<p class="ui-dialog-body">'+
((__t=( M.html.htmlAttributeEscape(bodyText) ))==null?'':__t)+
'</p>\n';
 } else { 
__p+='\n<div class="ui-dialog-body"></div>\n';
 } 
__p+='\n';
 if (previewImage) { 
__p+='\n  <div class="tiled-preview-container">\n    <p id="tiled-preview-info-text" class="tiled-preview-info-text">\n      A tiled preview of your design is shown below. Please confirm that your\n      submission is correct or upload a new file.\n    </p>\n    '+
((__t=( previewImage ))==null?'':__t)+
'\n  </div>\n';
 } 
__p+='\n';
 if (createWithButtons) { 
__p+='\n  <ul id="button-group" class="buttonGroup floatR">\n    ';
 if (previewImage) { 
__p+='\n      <li>\n        <progress id="asset-upload-progress-bar" class="file-upload-progress-bar grid_4 hide_div" value="0" max="100"></progress>\n      </li>\n    ';
 } 
__p+='\n    ';
 if (secondaryButtonText) { 
__p+='\n      <li>\n        ';
 if (previewImage) { 
__p+='\n          <button id="dialog-new-file-button" class="buttonFlat buttonGhostColored buttonMedium buttonSecondary">\n            '+
((__t=( M.html.htmlAttributeEscape(secondaryButtonText) ))==null?'':__t)+
'\n          </button>\n        ';
 } else { 
__p+='\n          <button class="buttonFlat buttonGhostColored buttonSmall buttonSecondary">\n            '+
((__t=( M.html.htmlAttributeEscape(secondaryButtonText) ))==null?'':__t)+
'\n          </button>\n        ';
 } 
__p+='\n      </li>\n    ';
 } 
__p+='\n    <li>\n      ';
 if (previewImage) { 
__p+='\n        <button id="dialog-upload-button" class="buttonFlat buttonMedium buttonPrimary">\n          '+
((__t=( M.html.htmlAttributeEscape(primaryButtonText) ))==null?'':__t)+
'\n        </button>\n      ';
 } else { 
__p+='\n        <button class="buttonFlat buttonSmall buttonPrimary">\n          '+
((__t=( M.html.htmlAttributeEscape(primaryButtonText) ))==null?'':__t)+
'\n        </button>\n      ';
 } 
__p+='\n    </li>\n  </ul>\n';
 } 
__p+='\n';
}
return __p;
});

M.Template.Util.Pagination = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n';
 if (isAllItems) { 
__p+='\n  <a class="viewAll less">view less</a>\n';
 } else { 
__p+='\n  ';
 if (isFirstPage) { 
__p+='\n    <span>previous</span>\n  ';
 } else { 
__p+='\n    <a class="pageLink"\n        href="#'+
((__t=( M.html.htmlAttributeEscape(currentPageNum - 1) ))==null?'':__t)+
'">\n      previous\n    </a>\n  ';
 } 
__p+='\n  <span>|</span>\n  ';
 _.each(toRender, function(item) { 
__p+='\n    ';
 var liClass = 'pageLink' 
__p+='\n    ';
 if (item == currentPageNum || isAllItems) { 
__p+='\n      ';
 liClass += (' ' + selectedClass) 
__p+='\n    ';
 } 
__p+='\n    ';
 if (item === ELLIPSIS) { 
__p+='\n      <span>'+
((__t=( M.html.htmlAttributeEscape(ELLIPSIS) ))==null?'':__t)+
'</span>\n    ';
 } else { 
__p+='\n      <a class="'+
((__t=( M.html.htmlAttributeEscape(liClass) ))==null?'':__t)+
'"\n          href="#'+
((__t=( M.html.htmlAttributeEscape(item) ))==null?'':__t)+
'">\n        '+
((__t=( M.html.htmlAttributeEscape(item) ))==null?'':__t)+
'\n      </a>\n    ';
 } 
__p+='\n  ';
 }) 
__p+='\n  <span>|</span>\n  ';
 if (currentPageNum == lastPageNum) { 
__p+='\n    <span>next</span>\n  ';
 } else { 
__p+='\n    <a class="pageLink"\n        href="#'+
((__t=( M.html.htmlAttributeEscape(currentPageNum + 1) ))==null?'':__t)+
'">\n      next\n    </a>\n  ';
 } 
__p+='\n  <span>|</span>\n  <a class="viewAll all">view all</a>\n';
 } 
__p+='\n';
}
return __p;
});

M.Template.Util.Row = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   * All Rights Reserved
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="merchtoolsDragIconWrapper floatL">\n  <img class="sprite merchtoolsDragIcon-hide floatL"\n      src="'+
((__t=(M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'"/>\n</div>\n\n';
 if (hasCheckboxColumn) { 
__p+='\n  <div class="checkboxCol checkbox gridCol floatL">\n  ';
 if (isCheckboxVisible) { 
__p+='\n    <input type="checkbox" class="gridWidgetCheckbox"/>\n  ';
 } 
__p+='\n  </div>\n';
 } 
__p+='\n';
 if (hasPositionColumn) { 
__p+='\n  <div class="positionCol positionWrapper gridCol floatL">\n    <input type="text" class="positionInput floatL"\n        maxlength=\n            "'+
((__t=( M.html.htmlAttributeEscape(maxNumOfCharForPositionInput) ))==null?'':__t)+
'"\n        value= "'+
((__t=( M.html.htmlAttributeEscape(model.get('weight')) ))==null?'':__t)+
'"\n        ';
 if (isPositionColumnDisabled) { 
__p+='\n          disabled\n        ';
 } 
__p+='\n    />\n  </div>\n';
 } 
__p+='\n<div class="customizedCols"></div>\n';
 if (hasActionsColumn) { 
__p+='\n  <div class="actionsCol gridCol floatR">\n    <div class="verticalCenter actionsButtonContainer"></div>\n  </div>\n';
 } 
__p+='\n';
}
return __p;
});

M.Template.Util.VimeoVideoOverlay = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY
   */
__p+='\n\n<iframe class="vimeoVideoIframe"\n  src="https://player.vimeo.com/video/'+
((__t=( encodeURIComponent(vimeoVideoId) ))==null?'':__t)+
'?api=1"\n  width="'+
((__t=( M.html.htmlAttributeEscape(videoWidth) ))==null?'':__t)+
'"\n  height="'+
((__t=( M.html.htmlAttributeEscape(videoHeight) ))==null?'':__t)+
'"\n  frameborder="0"\n  webkitAllowFullScreen mozallowfullscreen allowFullScreen>\n</iframe>\n<a class="videoCloseButton hideOnMobile"><img class="sprite closeXWhiteIcon"\n  src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"></a>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
